import { FormOrientationContext } from 'components/common-form/contexts/FormOrientationContext';
import { useFieldMetadata } from 'components/common-form/hooks/useFieldMetadata';
import { RefreshSchedule } from 'components/shared/RefreshSchedule/RefreshSchedule';
import type { ProductNode } from 'state/product-description/model';
import type { BatchWorkspaceVersion, QuoteWorkspaceVersion } from 'state/userPreferences/userPreferences.model';
import type { WorkspaceType } from 'state/workspaces/model';

import { RenderFormNodeComponent } from '../../FormBuilder';
import type { ProductNodeBuilderProps } from '../ProductNodeBuilder.model';

interface SubChildProps {
  tabId: string;
  subChild: ProductNode;
  level: number;
  workspaceType: WorkspaceType;
  quoteWorkspaceVersion: QuoteWorkspaceVersion;
  batchWorkspaceVersion: BatchWorkspaceVersion;
  mustForceAdvancedMode: boolean;
}

function SubChild({ subChild, level, ...tabProps }: SubChildProps) {
  const metadata = useFieldMetadata(subChild.id);

  if (metadata?.isHidden === true) {
    return null;
  }

  return (
    <div className={`field-${subChild.id}`}>
      <RenderFormNodeComponent level={level + 1} node={subChild} {...tabProps} />
    </div>
  );
}

export function ScheduleFooterBlock({
  tabId,
  level,
  node: { children, id },
  workspaceType,
  quoteWorkspaceVersion,
  batchWorkspaceVersion,
  mustForceAdvancedMode,
  batchTabId,
}: ProductNodeBuilderProps) {
  const isScheduleDatesFooter = id === 'ScheduleDatesFooter';

  return (
    <div className="w-100 d-flex h-100 align-items-center overflow-x-auto">
      <FormOrientationContext.Provider value="bar">
        {children!
          .filter(child => child.type !== 'ExportGridButton')
          .map(subChild => {
            return (
              <SubChild
                key={subChild.id}
                tabId={tabId}
                subChild={subChild}
                level={level}
                workspaceType={workspaceType}
                quoteWorkspaceVersion={quoteWorkspaceVersion}
                batchWorkspaceVersion={batchWorkspaceVersion}
                mustForceAdvancedMode={mustForceAdvancedMode}
              />
            );
          })}
        <div className="flex-grow-1 d-flex text-nowrap h-100">
          {children!
            .filter(child => child.type === 'ExportGridButton')
            .map(subChild => {
              return (
                <SubChild
                  key={subChild.id}
                  tabId={tabId}
                  subChild={subChild}
                  level={level}
                  workspaceType={workspaceType}
                  quoteWorkspaceVersion={quoteWorkspaceVersion}
                  batchWorkspaceVersion={batchWorkspaceVersion}
                  mustForceAdvancedMode={mustForceAdvancedMode}
                />
              );
            })}
          {isScheduleDatesFooter && (
            <RefreshSchedule tabId={batchTabId ?? tabId} formId={tabId} className="text-secondary btn-flat-secondary" />
          )}
        </div>
      </FormOrientationContext.Provider>
    </div>
  );
}
ScheduleFooterBlock.displayName = 'ScheduleFooterBlock';
